"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServerError_1 = __importDefault(require("./ServerError"));
class BadRequestServerError extends ServerError_1.default {
    constructor(response, responseData) {
        super('BadRequestServerError', response, responseData);
    }
}
exports.default = BadRequestServerError;
